import { MrbBaseRouteStore } from "mrb/core";
import { AppStoreHomeSectionService } from "common/services";

class NakiStoreHomeSectionListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(AppStoreHomeSectionService);
    }

    async getAll() {
        const response = await this.service.getNakiAll({
            embed: "items,items.nakiNigunAlbum,items.nakiNigunArtist,items.station,items.podcast",
        });
        return response.data;
    }

    async update(resources) {
        const response = await this.service.updateNaki(resources);
        return response.data;
    }

    async getContent(filter) {
        const response = await this.service.getNakiContent(filter);
        return response.data;
    }
}

export default NakiStoreHomeSectionListRouteStore;
